import { LoadingOverlay, BackgroundImage } from '@mantine/core'
import { clsx } from 'clsx'
import React, { type ReactNode } from 'react'

import { useTranslation } from '@flecto/translations'
import { useCloudflareUrl } from '@flecto/utils'

import { useItemGeneratorAI } from '../../../flecto-modules-saas/src/products/hooks/useItemGeneratorAI'
import { BoxActions } from './BoxActions'
import { type ItemPhotoForManager } from './PhotoManager'
import styles from './styles.module.css'

type BoxItemPhotoProps = {
  title?: string
  photo?: ItemPhotoForManager
  error?: ReactNode
}

export function BoxItemPhoto({
  title,
  photo,
  error,
  ...props
}: BoxItemPhotoProps) {
  const { t } = useTranslation('saas', { keyPrefix: 'items' })
  const { getUrl } = useCloudflareUrl()

  const { isLoading: isLoadingAI, isLoadingImageSingle } = useItemGeneratorAI()

  const isLoading =
    isLoadingAI.images || isLoadingImageSingle(photo?.order ?? 0)

  const classes = clsx(styles.photo, {
    [styles.mainPhoto]: photo?.main,
    [styles.photoWithError]: error,
  })

  const photoUrl = getUrl(photo?.photo_url, {
    noImageTitle: t('label_no_image'),
  })

  return (
    <BackgroundImage
      h='100%'
      w='100%'
      data-testid='box-photo'
      src={photoUrl}
      className={classes}
      {...props}
    >
      <LoadingOverlay
        visible={isLoading}
        loaderProps={{ size: !photo?.main ? 'sm' : undefined }}
        data-testid='box-photo-loader'
      />
      <BoxActions
        pb='sm'
        pos='absolute'
        bottom={0}
        title={title}
        photo={photo}
      />
    </BackgroundImage>
  )
}
